<template>
  <div>
    <a class="ag-nomal-action-menu" href="javascript:void(0);" @click="deleteProjectPhase">
      <i class="material-icons-outlined align-middle">delete</i>
    </a>
  </div>
</template>

<script>
export default {
  methods: {
    deleteProjectPhase: function() {
      this.params.context.componentParent.deleteProjectPhase(this.params.data);
    }
  }
};
</script>
